import { render, staticRenderFns } from "./create-edit-payment-method-modal.vue?vue&type=template&id=4e5c7472&scoped=true&lang=pug"
import script from "./create-edit-payment-method-modal.vue?vue&type=script&lang=ts"
export * from "./create-edit-payment-method-modal.vue?vue&type=script&lang=ts"
import style0 from "./create-edit-payment-method-modal.vue?vue&type=style&index=0&id=4e5c7472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c7472",
  null
  
)

export default component.exports